import { API_URL_COUPONS } from '../constants';
import axios from '../utils/axios';

// eslint-disable-next-line import/prefer-default-export
export const getCoupon = async (id) => {
  const response = await axios.get(`${API_URL_COUPONS}/${id}`);
  return response.data;
};
